import {
  ChangeDetectorRef,
  Component,
  OnDestroy,
} from '@angular/core';
import { MatCalendar } from '@angular/material/datepicker';
import { DateAdapter } from '@angular/material/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import * as moment from 'moment';



@Component({
  selector: 'custom-datepicker-header',
  template: `
    <div class="custom-calendar-header">
      <button class="custom-calendar-header-button-left" mat-icon-button (click)="previousClicked('month')">
        <mat-icon>chevron_left</mat-icon>
      </button>
      <span class="h6_500">{{periodLabel}}</span>
      <button class="custom-calendar-header-button-right" mat-icon-button (click)="nextClicked('month')">
        <mat-icon>chevron_right</mat-icon>
      </button>
    </div>
  `,
  styleUrls: ['./custom-datepickers.component.scss'],
})
export class CustomDatepickerHeader<D> implements OnDestroy {
  private _destroyed = new Subject<void>();

  constructor(
    private _calendar: MatCalendar<D>,
    private _dateAdapter: DateAdapter<D>,
    cdr: ChangeDetectorRef,
    private translate: TranslateService
  ) {
    _calendar.stateChanges
      .pipe(takeUntil(this._destroyed))
      .subscribe(() => cdr.markForCheck());

    // Configurar el idioma inicial y suscribirse a cambios
    this.setLocale(this.translate.currentLang);
    this.translate.onLangChange
      .pipe(takeUntil(this._destroyed))
      .subscribe(event => {
        this.setLocale(event.lang);
      });
  }

  private setLocale(lang: string) {
    moment.locale(lang);
    this._dateAdapter.setLocale(lang);
  }

  ngOnDestroy() {
    this._destroyed.next();
    this._destroyed.complete();
  }

  get periodLabel() {
    const date = this._calendar.activeDate as any;
    if (moment.isMoment(date)) {
      return date.locale(this.translate.currentLang).format('MMMM').charAt(0).toUpperCase() + date.locale(this.translate.currentLang).format('MMMM').slice(1).toLowerCase();
    }
    return '';
  }

  previousClicked(mode: 'month' | 'year') {
    this._calendar.activeDate = mode === 'month' ?
      this._dateAdapter.addCalendarMonths(this._calendar.activeDate, -1) :
      this._dateAdapter.addCalendarYears(this._calendar.activeDate, -1);
  }

  nextClicked(mode: 'month' | 'year') {
    this._calendar.activeDate = mode === 'month' ?
      this._dateAdapter.addCalendarMonths(this._calendar.activeDate, 1) :
      this._dateAdapter.addCalendarYears(this._calendar.activeDate, 1);
  }
}
